import { mapParamsBySchema } from '../../../util';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import { M_NOT_BASIC_03_Schema } from './M_NOT_BASIC_03_Schema';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic02R2, params);
  }, successOptions);
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.PolicyAndGoals.getPolBasic01R3,
      params
    );
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic02R1, params);
  }, successOptions);
};
export const useSearch4 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search4,
      context
    );
    return apiRequest(
      'post',
      Global.urls.PolicyAndGoals.getPolBasic01R2,
      params
    );
  }, successOptions);
};

/** 비상대응메뉴얼얼 목록 */
export const useSearch5 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search5,
      context
    );
    return apiRequest(
      'post',
      Global.urls.EmergencyManual.getEmrBasic01R1,
      params
    );
  }, successOptions);
};

/** 비상대응메뉴얼 상세 */
export const useSearch6 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_03_Schema.mapper.search6,
      context
    );
    return apiRequest(
      'post',
      Global.urls.EmergencyManual.getEmrBasic01R2,
      params
    );
  }, successOptions);
};
